import React from 'react'

import {Chip, Tooltip, Typography} from '@material-ui/core'
import ScheduleIcon from '@material-ui/icons/Schedule'

class FieldDateTime extends React.Component {
    render(){
        const value = this.props.hasOwnProperty('value')
            ? this.props.value
            : ""
        if( !value )
            return null

        const compact = this.props.hasOwnProperty('compact')
            ? this.props.compact
            : true

        return compact
            ? <Tooltip title={value} placement="right">
                <ScheduleIcon color="secondary" fontSize="small" />
            </Tooltip>
            : <Chip size="small" variant="outlined"
                icon={<ScheduleIcon color="secondary" fontSize="small" />}
                label={<Typography variant="body2" component="span" style={{fontSize: "0.7rem"}}>
                    {value}
                </Typography>}
            />
    }
}
export default FieldDateTime